export default __webpack_public_path__ + "static/media/629.67480c70.jpg";